export function PageNotFound() {
  return (
    <div className="mt-10">
      <h1>
        <div className="w-full max-w-xs mx-auto">Page not found</div>
      </h1>
    </div>
  )
}
